import { InjectionToken } from '@angular/core';

export const SOFTLINE_MODULE_AI_TABLE_EXTRACTOR = 'ai-table-extractor';
export const SOFTLINE_PERMISSION_AI_TABLE_EXTRACTOR = 'SOFTAPP.AI_TABLE_EXTRACTOR';

export interface AiTableExtractorModuleConfig {
  /** Base URL of the belegleser extraction service. Relative = same origin. */
  apiBaseUrl?: string;
  /** Delay between two GET /jobs/{id} polls while a job is processing. */
  pollIntervalMs?: number;
  /** Overall poll budget — the GPU pipeline downloads models on its first run. */
  pollTimeoutMs?: number;
  /** Own company identity passed along with an upload (recipient-side matching). */
  ownCompany?: { name?: string; address?: string; uids?: string[] };
}

export const DEFAULT_AI_TABLE_EXTRACTOR_CONFIG: Required<AiTableExtractorModuleConfig> = {
  apiBaseUrl: '/ai-table-extractor/api',
  pollIntervalMs: 1500,
  pollTimeoutMs: 300_000,
  ownCompany: {},
};

export const SOFTLINE_CONFIG_AI_TABLE_EXTRACTOR =
  new InjectionToken<AiTableExtractorModuleConfig>('SOFTLINE_CONFIG_AI_TABLE_EXTRACTOR', {
    factory: () => DEFAULT_AI_TABLE_EXTRACTOR_CONFIG,
  });
